import { SvgCallToAction } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import {
  endCTAFlow,
  endThumbnailFlow,
  endVideoSettingsFlow,
  startCTAFlow,
} from 'actions/editor';
import { requestVideoPlayerLeaveFullScreen } from 'actions/videoPlayer';
import { toggleViewerInsightsUI } from 'actions/viewerInsights';
import {
  ADD_CALL_TO_ACTION_UPGRADE_BUTTON_CLICKED,
  ADD_CUSTOM_VIDEO_CTA_CLICKED,
  SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
} from 'constants/events';
import { handleToggleTranscriptCreator } from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';

import { hasScope } from 'selectors/scopes';
import { selectUserCanEditVideo } from 'selectors/shareVideo';
import { selectIsActive } from 'selectors/viewerInsights';

import CollapsibleSideButton from '../collapsible-side-button';
import { VIDEO_CTA_ACCESS } from '../../../../../shared/constants/scopes';

import UpgradeTooltip from 'components/upgrade-tooltip';

class AddVideoCtaButton extends React.Component {
  render() {
    const {
      ctaEnabled,
      disabled,
      hasCTAScope,
      isCollapsed,
      userCanEditVideo,
    } = this.props;

    // Show if url arg is there or if the user has already enabled it
    let button = null;

    if (hasCTAScope) {
      button = (
        <CollapsibleSideButton
          icon={<SvgCallToAction />}
          isCollapsed={isCollapsed}
          isDisabled={disabled}
          onClick={this.handleClick}
        >
          {ctaEnabled ? 'Edit call-to-action' : 'Call-to-action'}
        </CollapsibleSideButton>
      );
    } else {
      button = (
        <UpgradeTooltip
          analyticsEvent={ADD_CALL_TO_ACTION_UPGRADE_BUTTON_CLICKED}
          placement="leftCenter"
          title="Call-to-action"
        >
          <CollapsibleSideButton
            icon={<SvgCallToAction />}
            isCollapsed={isCollapsed}
            isDisabled
            isUpgrade
          >
            Call-to-action
          </CollapsibleSideButton>
        </UpgradeTooltip>
      );
    }

    return userCanEditVideo && !isMobile && button;
  }

  handleUpgradeUpsell = () => {
    analytics.track(
      SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
      {
        fab_type: 'cta',
      },
      () => {
        window.location.href = '/account-settings?showUpgrade=true#billing';
      }
    );
  };

  handleClick = () => {
    const {
      areVideoCtaSettingsOpen,
      areVideoSettingsOpen,
      areViewerInsightsOpen,
      areThumbnailSettingsOpen,
      endCTAFlow,
      endVideoSettingsFlow,
      endThumbnailFlow,
      isVideoPlayerFullScreen,
      requestVideoPlayerLeaveFullScreen,
      startCTAFlow,
      toggleViewerInsightsUI,
      isTranscriptVisible,
      handleToggleTranscriptCreator,
    } = this.props;

    if (areVideoCtaSettingsOpen) {
      endCTAFlow();

      return;
    }

    analytics.track(ADD_CUSTOM_VIDEO_CTA_CLICKED);

    if (areViewerInsightsOpen) {
      toggleViewerInsightsUI();
    }

    if (areVideoSettingsOpen) {
      endVideoSettingsFlow();
    }

    if (areThumbnailSettingsOpen) {
      endThumbnailFlow();
    }

    if (isTranscriptVisible) {
      handleToggleTranscriptCreator();
    }

    // we only request leaving full screen if already full screen,
    // otherwise we queue up the request to leave full screen
    if (isVideoPlayerFullScreen) {
      requestVideoPlayerLeaveFullScreen();
    }

    startCTAFlow();
  };
}

const mapStateToProps = state => {
  const { cta_enabled: ctaEnabled } = state.share_video;

  return {
    areVideoCtaSettingsOpen: state.editor?.cta_flow,
    areVideoSettingsOpen: state.editor?.video_settings_flow,
    areViewerInsightsOpen: selectIsActive(state),
    areThumbnailSettingsOpen: state.editor?.thumbnail_flow,
    ctaEnabled,
    hasCTAScope: hasScope(state, VIDEO_CTA_ACCESS),
    isVideoPlayerFullScreen: state.video_player?.full_screen,
    userCanEditVideo: selectUserCanEditVideo(state),
    workspaces: state.workspace?.workspaces,
  };
};

const mapDispatchToProps = dispatch => ({
  endVideoSettingsFlow: () => dispatch(endVideoSettingsFlow()),
  requestVideoPlayerLeaveFullScreen: () =>
    dispatch(requestVideoPlayerLeaveFullScreen()),
  startCTAFlow: () => dispatch(startCTAFlow()),
  endCTAFlow: () => dispatch(endCTAFlow()),
  toggleViewerInsightsUI: () => dispatch(toggleViewerInsightsUI()),
  endThumbnailFlow: () => dispatch(endThumbnailFlow()),
  handleToggleTranscriptCreator: () =>
    dispatch(handleToggleTranscriptCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVideoCtaButton);
